import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ILineChartData } from '../../models';
import { InputValuesQualityWidget } from './inputValuesQuality.widget';
import { IinputValuesStatusService, IDateRangeService, IwidgetIntervalHelperService } from '../../services';
import { refreshClick } from '../../common/';

class InputValuesQualityController implements angular.IComponentController {
    item: InputValuesQualityWidget;
    isLoading: boolean;
    statuses: any[];
    hovered: ILineChartData;
    clicked: ILineChartData;

    static $inject = ['$scope', 'inputValuesStatusService', 'dateRangeService', 'widgetIntervalHelperService'];

    constructor(private _$scope: angular.IScope,
        private _inputValuesStatusService: IinputValuesStatusService,
        private _dateRangeService: IDateRangeService,
        private _widgetIntervalHelperService: IwidgetIntervalHelperService) {
    }

    $onInit() {
        this._$scope.$on(refreshClick, (event, data) => {
            this.refresh(this.item, !!data.force);
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['item'] && changesObj['item'].currentValue) {
            const item = changesObj['item'].currentValue;
            if (item) {
                this.refresh(item);
            }
        }
    }

    private refresh(item: InputValuesQualityWidget, force: boolean = false) {
        if (this._dateRangeService.initialized() && item) {
            this.isLoading = true;

            const defaultInterval = this._widgetIntervalHelperService.getCurrentInclusiveInterval();
            const beginDate = defaultInterval.beginDate;
            const endDate = defaultInterval.endDate;

            this._inputValuesStatusService
                .getTagStatusesBetweenDates(
                    item.configuration.guid,
                    item.configuration.type,
                    beginDate,
                    endDate,
                    force
                )
                .then((data) => {
                    this.statuses = _.sortBy(data, (d: any) => d.statusId);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}

export const wtInputValuesQuality: ComponentDefinition = {
    componentId: 'wtInputValuesQuality',
    controller: InputValuesQualityController,
    template: require('./inputValuesQuality.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        hovered: '=',
        clicked: '=',
        boundData: '<?'
    }
};
